import { Type, Unit } from "@/commons/services/SendDocuments";

/**
 * ### S3ファイルアップロードリクエスト
 */
export interface S3MultiLocation {
  /** S3のURL作成種別 */
  type: S3UploadType;
  /** アップロード種別毎のパラメータ */
  params: S3UploadParamBase;
  /** 公開設定 */
  acl?: string;
}
/**
 * ### S3ファイルアップロードレスポンス
 */
export interface S3UploadResponse {
  [key: string]: Array<S3UploadResponseFile>;
}

export interface S3UploadResponseFile {
  /** ファイルURL */
  url: string;
  /** ファイル格納用パラメータ */
  fields: {
    /**
     * フォームデータとして設定するシグネチャ等の情報
     * ファイルの種別毎に増減するため、key数は不定
     */
    [key: string]: string;
  };
}

/**
 * S3URL作成種別
 */
export enum S3UploadType {
  /** 文書送付 */
  SEND_DOCUMENT = 0
}

export interface S3UploadParamBase {
  /** アップロード対象のファイル情報 */
  files: Array<S3UploadFileInfo>;
}

export interface S3UploadFileInfo {
  /** ファイル数 ファイル名が複数ある場合は連番にする必要があるので、欲しいUrl数を渡す */
  count: number;
  /** 拡張子配列 */
  extensions: Array<string>;
  /** ソートキー */
  sortKey: string;
}

/**
 * S3URL作成 文書送付時のパラメータ
 */
export interface S3UploadSendDocument extends S3UploadParamBase {
  /** 種別 */
  type: Type;
  /** 文書単位 */
  unit: Unit;
}
